import { Summary } from "./Summary";
import { SectionCard } from "@/components";
import { WhyChoose } from "./WhyChoose";
import { Button } from "@/components/ui";
import { OurProducts } from "./OurProducts";
import { Certification } from "./Certification";
import { Testimonials } from "./Testimonials";
import { HealthGrow } from "./HealthGrow";
import { ReactTyped } from "react-typed";
import { Meta, SchemaMarkup } from "@/components";

const Home = () => {
  return (
    <>
      <Meta
        title="Intron - Home"
      />
      <SchemaMarkup type="Organization" />

      <div className="px-4 py-1 mx-0 mb-10 sm:px-8 md:px-40">
        <div className="grid grid-cols-1 items-center lg:grid-cols-2">
          {/* Left side text */}
          <div className="mt-8 sm:mt-8 lg:-mt-5 flex flex-col justify-center items-start lg:items-center">
            <div className="flex flex-col items-start lg:items-start w-full lg:w-fit">
              <span
                className="block leading-tight font-extrabold tracking-tight 
                      text-left sm:text-center 
                      text-5xl sm:text-6xl md:text-7xl lg:text-8xl
                      h-[300px] sm:h-[380px] md:h-[400px] lg:h-[420px] 
                      flex flex-col justify-center items-start lg:items-start"
              >
                <div className="h-full flex flex-col justify-center">
                  <ReactTyped
                    strings={[
                      `<span class="text-[#E85222] fade-text">Innovate</span><br/>` +
                      `<span class="text-green fade-text"><span class="lg:mr-[70px]">Impact</span></span><br/>` +
                      `<span class="text-[#1a7fc2] fade-text"><span class="lg:mr-[60px]">Inspire</span></span>`,
                      `<span class="text-[#E85222] fade-text">Innovate</span><br/>` +
                      `<span class="text-green fade-text"><span class="lg:mr-[70px]">Impact</span></span><br/>` +
                      `<span class="text-[#1a7fc2] fade-text"><span class="lg:mr-[60px]">Inspire</span></span>`
                    ]}
                    typeSpeed={70}
                    backSpeed={50}
                    backDelay={1500}
                    loop={true}
                    smartBackspace={false}
                    fadeOut={true}
                    showCursor={true}
                    cursorChar="|"
                  />
                </div>

              </span>
              <p className="mt-4 text-xs sm:text-sm md:text-base lg:text-lg font-bold tracking-widest uppercase text-left sm:text-center lg:text-start">
                <span className="orange-shine">Serving The World Through</span>
                <br />
                <span className="blue-shine lg:whitespace-nowrap">
                  Innovative, Effective and Sustainable Solutions
                </span>
              </p>
            </div>
          </div>


          {/* Right side image section */}
          <div className="relative flex justify-center w-full h-[290px] sm:h-[400px] md:h-[450px] lg:w-[600px] lg:h-[520px] bg-[url('/img/home-hero-bg.png')] bg-no-repeat bg-center bg-contain mt-6 lg:mt-0">

            <div>
              {/* Shrimp - top left */}
              <div className="absolute top-4 left-0 sm:top-6 sm:left-6 rotate-45 overflow-hidden rounded-xl w-30 h-30 sm:w-24 sm:h-24 md:w-28 md:h-28 lg:w-70 lg:h-70 lg:top-15 lg:left-0 flex items-center justify-center float-up">
                <img
                  src="/img/Home/Shrimp.png"
                  alt="shrimp"
                  className="-rotate-45 object-cover w-full h-full"
                />
              </div>
              <div className="hidden lg:block absolute top-5 left-50 mr-10 w-25 h-25 bg-primary rounded-full z-0 float-animation" />
              <div className="hidden lg:block absolute top-30 right-65 w-5 h-5 bg-primary rounded-full z-0 float-animation" />

              {/* Fish - bottom left */}
              <div className="absolute top-25 left-12 sm:top-32 sm:left-16 rotate-45 overflow-hidden rounded-xl w-30 h-30 sm:w-24 sm:h-24 md:w-28 md:h-28 lg:w-65 lg:h-65 lg:top-55 lg:left-38 flex items-center justify-center float-down">
                <img
                  src="/img/Home/Fish.png"
                  alt="fish"
                  className="-rotate-45 object-cover w-full h-full"
                />
              </div>

              {/* Chicken - top right */}
              <div className="absolute top-4 right-14 sm:top-6 sm:right-6 rotate-45 overflow-hidden rounded-xl w-30 h-30 sm:w-24 sm:h-24 md:w-28 md:h-28 lg:w-65 lg:h-65 lg:top-15 lg:left-78 flex items-center justify-center float-up">
                <img
                  src="/img/Home/Poultry.png"
                  alt="chicken"
                  className="-rotate-45 object-cover w-full h-full"
                />
              </div>
              <div className="hidden lg:block absolute -bottom-0 right-8 mr-10 w-25 h-25 bg-primary rounded-full z-0 float-animation" />
              <div className="hidden lg:block absolute bottom-20 right-35 mr-15 w-5 h-5 bg-primary rounded-full z-0 float-animation" />

              {/* Cow - bottom right */}
              <div className="absolute top-25 right-3 sm:top-32 sm:right-16 rotate-45 overflow-hidden rounded-xl w-30 h-30 sm:w-24 sm:h-24 md:w-28 md:h-28 lg:w-65 lg:h-65 lg:top-46 lg:left-[470px] flex items-center justify-center float-down">
                <img
                  src="/img/Home/Ruminant.png"
                  alt="cow"
                  className="-rotate-45 object-cover w-full h-full"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Other sections remain untouched */}
      <Summary />
      <WhyChoose />
      <OurProducts />
      <Certification />
      <HealthGrow />
      <Testimonials />
    </>
  );
};

export default Home;
